import { BoardTypeEnum } from 'modules/core/domain/interfaces/supabase/overlay/auxiliary-types';

/** Категории кнопок «Добавить плейсхолдер» — значения `value` из `category-list.ts`; единственный список. */
export const PLACEHOLDER_CATEGORIES = ['common', 'complex', 'events', 'carousel'] as const;

export type PlaceholderCategory = (typeof PLACEHOLDER_CATEGORIES)[number];

/**
 * Какие категории плейсхолдеров можно ставить на табло этого типа.
 *
 * Плейсхолдеры событий подставляются только на табло событий, карусели — только на карусель;
 * обычные и составные — везде. Тип неизвестен (новое табло ещё не сохранено) — как у `static`.
 * Правило общее для редактора и генератора шаблонов (`.claude/skills/broadcast-templates`).
 */
export function allowedPlaceholderCategories(boardType: BoardTypeEnum | undefined): PlaceholderCategory[] {
  return PLACEHOLDER_CATEGORIES.filter((category) => {
    if (boardType === 'events') return category !== 'carousel';
    if (boardType === 'carousel') return category !== 'events';
    return category !== 'events' && category !== 'carousel';
  });
}
